export interface Suggest_Order_Interface {
  id:number,
  title:String,
  cls:String,
  icon:String,
  section_id:number,
}

export function Empty_Suggest_Order_Interface():Suggest_Order_Interface{
  return{
    id:0,
    title:'',
    cls:'',
    icon:'',
    section_id:0,
  }
}
